import { render } from "./TechDashboard.vue?vue&type=template&id=4f3703c0"
import script from "./TechDashboard.vue?vue&type=script&lang=js"
export * from "./TechDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__